import {
  DeleteOutlineIcon,
  MoreVerticalOutlineIcon,
} from '@carboncopyco/icons';
import type { Role, WorkspaceMember } from '@carboncopyco/types';
import type { PillVariant } from '@carboncopyco/ui';
import {
  Button,
  Dropdown,
  DropdownItem,
  Pill,
  UserBasicInfo,
} from '@carboncopyco/ui';
import classNames from 'classnames';
import { useState } from 'react';
import type { TableColumns } from './WorkspaceMembersModal';

export interface WorkspaceMemberTileRowProps {
  member: WorkspaceMember;
  columns: TableColumns;
  removeMember: () => void;
  isCurrentUser?: boolean;
  showDropdownButton?: boolean;
}

const roleToPillVariant: Record<WorkspaceMember['role'], PillVariant> = {
  admin: 'blue',
  editor: 'green',
  presenter: 'yellow',
  owner: 'primary',
};

export const WorkspaceMemberRow = ({
  member,
  columns,
  removeMember,
  isCurrentUser,
  showDropdownButton = true,
}: WorkspaceMemberTileRowProps) => {
  const [hover, setHover] = useState<boolean>(false);
  const [openDropdown, setOpenDropdown] = useState<boolean>(false);

  return (
    <div
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      className="flex items-center w-full px-ds-5 h-ds-11 hover:bg-ds-natural-50"
    >
      <div className={classNames(columns.member.width)}>
        <UserBasicInfo
          textColor="text-ds-natural-600"
          size="small"
          user={member.user}
        />
      </div>
      <div className="flex flex-auto items-center justify-between">
        <div className="w-ds-29 flex-shrink-0 flex justify-between items-center">
          {member.role && (
            <Pill
              label={member.role as Role}
              variant={roleToPillVariant[member.role]}
            />
          )}
        </div>
        <div className="w-full flex justify-end">
          {!isCurrentUser && showDropdownButton && (hover || openDropdown) && (
            <Dropdown
              align="start"
              interactive
              asChild
              open={openDropdown}
              onOpenChange={setOpenDropdown}
              triggerElement={
                <Button
                  aria-label="workspace member actions"
                  icon={<MoreVerticalOutlineIcon />}
                  link
                  secondary
                />
              }
            >
              <DropdownItem
                iconLeft={<DeleteOutlineIcon size={24} />}
                label="Remove member"
                onClick={removeMember}
              />
            </Dropdown>
          )}
        </div>
      </div>
    </div>
  );
};
